import { URI_REPORT } from '@/config/config';

export default async ({ rootState }, payload) => {
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
    },
    body: JSON.stringify(payload),
  };

  try {
    const userLoginInfoResult = await fetch(
      `${URI_REPORT}consumer/log-history`,
      opts,
    );
    const resultJson = await userLoginInfoResult.json();

    if (userLoginInfoResult.status !== 200) {
      return Promise.reject(resultJson);
    }

    return resultJson;
  } catch (error) {
    return Promise.reject(error);
  }
};
